import { ThemeOptions } from '@mui/material';

export const defaultTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#833CE2',
      light: '#ABD8F4',
      dark: '#1A8AD0'
    },
    secondary: {
      main: '#525B6E',
      '600': '#343D51',
      '700': '#23293A'
    },
    text: {
      primary: '#000000',
      secondary: '#525B6E'
    },
    success: {
      main: '#00C51F',
      light: '#E5F9E9',
      dark: '#2E7E25'
    },
    error: {
      main: '#F20000',
      light: '#FBDFDE',
      dark: '#953432'
    },
    warning: {
      main: '#E6AA40',
      light: '#FFDFBF',
      dark: '#9F613D'
    },
    info: {
      main: '#49A6EE',
      light: '#BFEBFF',
      dark: '#4368B1'
    }
  },
  typography: {
    fontFamily: 'Poppins',
    fontSize: 16,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    htmlFontSize: 16,
    h1: {
      fontSize: 24,
      fontWeight: 600,
      lineHeight: '130%'
    },
    h2: {
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '150%'
    },
    subtitle1: {
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '150%'
    },
    body1: {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '150%'
    },
    caption: {
      fontSize: 12,
      fontWeight: 400,
      lineHeight: '150%'
    }
  },
  shape: {
    borderRadius: 8
  },
  spacing: 8
};
